import { render, staticRenderFns } from "./TimestampCountdown.vue?vue&type=template&id=1ec71ec6&"
import script from "./TimestampCountdown.vue?vue&type=script&lang=js&"
export * from "./TimestampCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports